import angular from "angular";
import $ from 'jquery';

angular
    .module('ui-sentinel.login')
    .controller('LoginController', LoginController);

/////////////

export function classifyLoginError(error) {
    const data = error && error.data ? error.data : {};
    const isWebLoginFailure = error && error.status === 401;
    const errorDescription = (data.error_description || '').toLowerCase();
    const isSuspended = data.error === 'suspended_client'
        || (data.error === 'invalid_grant' && errorDescription === 'account has been suspended');

    if (isWebLoginFailure && isSuspended) {
        return 'suspended';
    }

    if (isWebLoginFailure && data.error === 'invalid_grant') {
        return 'invalid_credentials';
    }

    return 'server';
}

LoginController.$inject = ['$rootScope', '$state', '$interval', 'SentinelUiSession'];

function LoginController($rootScope, $state, $interval, SentinelUiSession) {

    const vm = {
        username: {
            value: null,
            isPristine: true,
            hasError: function () {
                return this.errors.isBlank;
            },
            errors: {
                isBlank: true
            },
            validate: function () {
                this.isPristine = false;
                this.errors.isBlank = !this.value;
            }
        },
        password: {
            value: null,
            isPristine: true,
            hasError: function () {
                return this.errors.isBlank;
            },
            errors: {
                isBlank: true
            },
            validate: function () {
                this.isPristine = false;

                if (!this.value) {
                    this.errors.isBlank = true;
                } else {
                    this.value = this.value.trim();
                    this.errors.isBlank = this.value === '';
                }
            }
        },
        inProcess: false,
        login: login,
        loginFailed: false,
        loginSuspend: false,
        serverError: false,
        date: new Date(),
        isOrs: $rootScope.isOrs,
        loginTitle: $rootScope.isOrs ? 'Login' : 'OAInsight Login',
        redirectUrl: null,
        redirectCountdown: 5
    };

    // listen for clientRedirect event
    $rootScope.$on('clientRedirect', function(event, redirectUrl) {
        vm.redirectUrl = redirectUrl;
        vm.redirectCountdown = 5;
        $('#clientRedirectModal').modal('show');

        const countdownInterval = $interval(function() {
            vm.redirectCountdown--;
            if (vm.redirectCountdown <= 0) {
                $interval.cancel(countdownInterval);
                window.location.href = redirectUrl;
            }
        }, 1000);
    });

    return vm;

    function login() {
        vm.inProcess = true;
        vm.loginFailed = false;
        vm.serverError = false;

        $('#btn-login').blur();

        if (!vm.username.value) {
            // check broken autofill...
            const check = $('#username').val();
            if (check) {
                vm.username.value = check;
                vm.username.isPristine = true;
            }
        }

        if (!vm.password.value) {
            // check broken autofill...
            const check = $('#password').val();
            if (check) {
                vm.password.value = check;
                vm.password.isPristine = true;
            }
        }

        vm.username.validate();
        vm.password.validate();

        if (vm.username.hasError() || vm.password.hasError()) {
            vm.inProcess = false;
            vm.loginFailed = true;
            return;
        }

        $rootScope.loading = true;
        const promise = SentinelUiSession.login(vm.username.value.trim(), vm.password.value.trim());
        promise.then(
            function (result) {
                vm.inProcess = false;
                if (!result.redirected) {
                    onSessionCreated();
                }
            },
            function (error) {
                vm.inProcess = false;
                if (SentinelUiSession.isSupersededResponse(error)) {
                    return;
                }
                const loginError = classifyLoginError(error);
                vm.loginSuspend = loginError === 'suspended';
                vm.loginFailed = loginError === 'invalid_credentials';
                vm.serverError = loginError === 'server';
                SentinelUiSession.clear();
                $rootScope.loading = false;
            }
        ).finally(function () {
            // do not set $rootScope.loading = false
            // this causes the gears to disappear and then reappear on login
        });
    }

    function onSessionCreated() {
        $state.go('home');
    }

}
